/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 */
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  ProtoFileUpload,
  protoFileUploadValidation,
} from './ProtoFileUploadExtension';

export const ProtoFileUploadExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ProtoFileUpload',
    component: ProtoFileUpload,
    validation: protoFileUploadValidation,
  }),
);
